module.exports = __webpack_public_path__ + "static/media/no-image.47c075ac.svg";